// @ts-nocheck
import React from 'react'
import { ErrorBox } from '../../../generic'
import {
  EmarMedicationRoundsField,
  EmarFrequencyField,
  EmarStartDateField,
  EmarEndDateField
} from '../fields'

interface EmarMedicationStartEndSectionProps {
  errors: Array<string>
  fields: Record<string, any> // Update the type as needed
  formId: string
  setFormField: (key: string, value: any) => void
  editState: boolean
  testId?: string
  // Add other props as needed
}

const renderErrorBox = (props: EmarMedicationStartEndSectionProps) => {
  const { errors } = props

  return <ErrorBox errors={errors} style={styles.errorBox} />
}

// Render field functions

const renderMedicationRoundsField = (
  props: EmarMedicationStartEndSectionProps
) => <EmarMedicationRoundsField readOnly={props.editState} {...props} />

const renderStartDateField = (props: EmarMedicationStartEndSectionProps) => {
  const { fields, formId, editState, setFormField, testId } = props

  return (
    <EmarStartDateField
      fields={fields}
      formId={formId}
      readOnly={editState}
      setFormField={setFormField}
      testId={testId}
    />
  )
}

const renderMedicationFrequencyField = (
  props: EmarMedicationStartEndSectionProps
) => {
  const { errors, fields, formId, setFormField, editState, testId } = props

  return (
    <EmarFrequencyField
      errors={errors}
      fields={fields}
      formId={formId}
      readOnly={editState}
      setFormField={setFormField}
      testId={testId}
    />
  )
}

const renderEndDateField = (props: EmarMedicationStartEndSectionProps) => {
  const { fields, formId, testId } = props

  return (
    <div
      style={styles.endDateFieldContainer}
      data-testid={
        testId ? `${testId}-end-date-container` : 'end-date-container'
      }
    >
      <EmarEndDateField formId={formId} fields={fields} testId={testId} />
    </div>
  )
}

/**
 * Renders start/end section of the Instructions Step
 * of the add med modal.
 *
 * @param errors - All form field errors. Also includes the rounds error if applicable.
 * @param fields - The form fields.
 * @param formId - addEmarMedication. Identifies the form.
 *
 * @returns {React.ReactNode} EmarMedicationStartEndSection.
 */
const EmarMedicationStartEndSection: React.FC<
  EmarMedicationStartEndSectionProps
> = (props) => {
  const { testId } = props
  return (
    <div
      data-testid={
        testId
          ? `${testId}-start-end-section-wrapper`
          : 'start-end-section-wrapper'
      }
    >
      {renderErrorBox(props)}
      {renderMedicationRoundsField(props)}
      {renderStartDateField(props)}
      {renderMedicationFrequencyField(props)}
      {renderEndDateField(props)}
    </div>
  )
}

const styles = {
  errorBox: {
    margin: '16px 0px'
  },
  endDateFieldContainer: {
    marginBottom: 24
  }
}

export default EmarMedicationStartEndSection
